import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';

import styles from '../styles/StatusBar.module.css';

interface Props {
  levelNumber: number;
  levelTitle: string;

  userMoves: number;
  idealMoves: number;
}

class StatusBar extends Component<Props> {
  render() {
    return (
      <Paper className={styles.statusBar}>
        <div className={styles.left}>
          <Typography inline variant="h4">
            Level {this.props.levelNumber + 1}:{' '}
            {this.props.levelTitle.toUpperCase()}
          </Typography>
        </div>
        <div className={styles.right}>
          <Typography inline variant="h4">
            Moves:{' '}
            <span
              className={classNames({
                [styles.warn]: this.props.userMoves > this.props.idealMoves
              })}
            >
              {this.props.userMoves}
            </span>
            /{this.props.idealMoves}
          </Typography>
          <div className={styles.level} />
        </div>
      </Paper>
    );
  }
}

export default StatusBar;
